export default __webpack_public_path__ + "static/media/desk1.ebe02cd5.png";